import { PushNotification, handleResponseErrors } from '@sit/client-shared';
import { t } from 'i18n-js';
import toastr from '../../helpers/toastr';
import { NotificationTopic, NotificationType } from './NotificationHandlerService';

type MessageMap = Partial<Record<NotificationType, string>>;

const displayToast = (notification: PushNotification, messageMap: MessageMap, options = {}): void => {
  const message = messageMap[notification.type];
  const toastId = notification.id || message;

  const toastFn = (msg: string): void => {
    switch (notification.type) {
      case 'SUCCESS':
        toastr.success(msg, { ...options, toastId });
        break;
      case 'WARNING':
        toastr.warning(msg, { ...options, toastId });
        break;
      case 'ERROR':
        toastr.error(msg, { ...options, toastId });
        break;
      default:
        toastr.info(msg, { ...options, toastId });
    }
  };

  if (message) {
    toastFn(message);
  }
};

export const toastNotification = (notification: PushNotification): unknown => {
  switch (notification.topic as NotificationTopic) {
    case NotificationTopic.SAVE_TIMESHEET:
      return displayToast(
        notification,
        {
          SUCCESS: t('notification.toasts.SAVE_TIMESHEET.SUCCESS'),
          ERROR: t('notification.toasts.SAVE_TIMESHEET.ERROR'),
        },
        {
          toastId: notification.data?.timesheetId,
        },
      );
    case NotificationTopic.SUBMIT_TIMESHEET:
      return displayToast(
        notification,
        {
          SUCCESS: t('notification.toasts.SUBMIT_TIMESHEET.SUCCESS'),
          ERROR: t('notification.toasts.SUBMIT_TIMESHEET.ERROR'),
        },
        {
          toastId: notification.data?.timesheetId,
        },
      );
    case NotificationTopic.APPROVALS: {
      const reason = notification.type === 'ERROR' ? handleResponseErrors(notification.data?.reason) : '';
      const toastId = notification.type === 'ERROR' ? reason : notification.id;
      return displayToast(
        notification,
        {
          SUCCESS: t(`notification.toasts.APPROVALS.${notification.data?.action ?? 'UNKNOWN'}.SUCCESS`),
          ERROR: t(`notification.toasts.APPROVALS.${notification.data?.action ?? 'UNKNOWN'}.ERROR`, {
            reason,
          }),
        },
        {
          toastId,
        },
      );
    }
    default:
      return null;
  }
};
